import axios from 'axios'

// const API_URL = '/api/schedaSpese/' // OK

// const API_URL = "https://budget-7ehi.onrender.com/api/schedaSpese/"; //OK!!!
const API_URL = process.env.REACT_APP_NODE_ENV === 'production' ? process.env.REACT_APP_BASE_URL + "/api/schedaSpese/" : '/api/schedaSpese/'; 


// Get single scheda spese
const singleSchedaSpeseGet = async (param, token) => {
  console.log(param, token, "kkkkkkkkkkkkkk");
  const paramUrl = param.schedaId ?? param 
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: param,
  };

  const response = await axios.get(API_URL + paramUrl, config);

  return response.data;
}
// Get all scheda spese
const getSchedaSpese = async (token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
  const response = await axios.get(API_URL, config)
  return response.data
}

// Get only personal scheda spese (paginated: { skip, limit })
const getPersonalSchedaSpese = async (token, { skip, limit } = {}) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: { skip, limit },
  }
  const response = await axios.get(API_URL + 'personal', config)
  return response.data
}

// Get only shared scheda spese (paginated: { skip, limit })
const getSharedSchedaSpese = async (token, { skip, limit } = {}) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: { skip, limit },
  }
  const response = await axios.get(API_URL + 'shared', config)
  return response.data
}

// Search scheda spese by titolo (owned or shared with me); server enforces the min-length gate too
const searchSchedaSpese = async (q, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: { q },
  }
  const response = await axios.get(API_URL + 'search', config)
  return response.data
}

// Create new events
const createSchedaSpese = async (schedaSpeseData, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }

  const response = await axios.post(API_URL, schedaSpeseData, config)

  return response.data
}

// // Update events
const updateSchedaSpese = async (schedaId, schedaData, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
  const response = await axios.put(API_URL + schedaId, schedaData, config)
  return response.data
}

// Delete scheda spese
const deleteSchedaSpese = async (schedaId, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
  const response = await axios.delete(API_URL + schedaId, config)
  // return response.data
  return { id: schedaId };
}

// Hide a shared scheda from my own list (optionally notify the owner)
const hideSchedaSpese = async ({ id, notifyOwner }, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
  const response = await axios.post(API_URL + id + '/hide', { notifyOwner }, config)
  return response.data
}

// Restore a scheda previously hidden from my own list
const unhideSchedaSpese = async (id, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
  const response = await axios.post(API_URL + id + '/unhide', {}, config)
  return response.data
}


const schedaSpeseService = {
  singleSchedaSpeseGet,
  getSchedaSpese,
  getPersonalSchedaSpese,
  getSharedSchedaSpese,
  searchSchedaSpese,
  createSchedaSpese,
  updateSchedaSpese,
  deleteSchedaSpese,
  hideSchedaSpese,
  unhideSchedaSpese,
}

export default schedaSpeseService